import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MarketingLayout } from "../../components/marketing/MarketingLayout";
import { SEO } from "../../components/seo/SEO";
import { breadcrumbSchema } from "../../components/seo/schema";
import { resourcesApi } from "../../lib/api";
import { Loader2 } from "lucide-react";

export default function BlogIndex() {
  const [articles, setArticles] = useState(null);
  useEffect(() => {
    resourcesApi.list("blog").then(setArticles).catch(() => setArticles([]));
  }, []);
  const breadcrumb = [{ name: "Home", path: "/" }, { name: "Resources", path: "/resources" }, { name: "Blog", path: "/resources/blog" }];

  return (
    <MarketingLayout breadcrumb={breadcrumb}>
      <SEO
        title="Blog | ServiceGuru Pro"
        description="Practical articles on dispatching, CRM, AI receptionists, invoicing, and running a home service business — written from real patterns, not filler."
        path="/resources/blog"
        jsonLd={[breadcrumbSchema(breadcrumb)]}
      />
      <section className="max-w-4xl mx-auto px-5 lg:px-8 pt-12 pb-10 text-center">
        <h1 className="text-4xl sm:text-5xl font-black tracking-tight leading-[1.05] mb-5" data-testid="blog-index-h1">
          Blog
        </h1>
        <p className="text-[15.5px] text-slate-400 leading-relaxed max-w-2xl mx-auto">
          Practical guidance for home service businesses — no filler, no fabricated stats.
        </p>
      </section>

      <section className="max-w-3xl mx-auto px-5 lg:px-8 pb-20">
        {!articles && (
          <div className="flex justify-center py-10" data-testid="blog-index-loading">
            <Loader2 className="h-6 w-6 text-slate-500 animate-spin" />
          </div>
        )}
        {articles && articles.length === 0 && (
          <p className="text-center text-slate-500 text-sm" data-testid="blog-index-empty">No articles published yet.</p>
        )}
        <div className="space-y-4">
          {articles?.map((a) => (
            <Link
              key={a.slug}
              to={`/resources/blog/${a.slug}`}
              data-testid={`blog-index-card-${a.slug}`}
              className="block rounded-2xl border border-white/10 bg-white/[0.02] p-6 hover:border-blue-400/50 hover:bg-white/[0.04] transition-colors group"
            >
              <p className="text-[11.5px] uppercase tracking-widest text-slate-500 mb-2">
                {new Date(a.publishedAt).toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" })}
              </p>
              <h2 className="text-white font-bold text-lg mb-2 group-hover:text-blue-400 transition-colors">{a.title}</h2>
              <p className="text-[13.5px] text-slate-400 leading-relaxed">{a.excerpt}</p>
            </Link>
          ))}
        </div>
      </section>
    </MarketingLayout>
  );
}
